import { createContext } from 'react';
const AddonComponentsContext = /*#__PURE__*/createContext({
  HandholdingBannerHelpers: {},
  ManualDetectedTaskButtons: {}
});
export default AddonComponentsContext;